import { defineMessages } from "react-intl"

export default defineMessages({
  weeklyPlaytimes: {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes",
  },
  "weeklyPlaytimes.0to5hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.0to5hours",
  },
  "weeklyPlaytimes.6to10hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.6to10hours",
  },
  "weeklyPlaytimes.11to15hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.11to15hours",
  },
  "weeklyPlaytimes.16to20hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.16to20hours",
  },
  "weeklyPlaytimes.21to30hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.21to30hours",
  },
  "weeklyPlaytimes.31to40hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.31to40hours",
  },
  "weeklyPlaytimes.41to60hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.41to60hours",
  },
  "weeklyPlaytimes.60+hours": {
    id: "app.components.WeeklyPlaytime.weeklyPlaytimes.60+hours",
  },
})
